import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import './Golden.css';
import GoldenDataService from "../../services/golden.service";
import SignUpDataService from "../../services/signup.service";
import LoggerDataService from "../../services/logger.service";
import Updated from "../Messages/Updated";
import Error from "../Error/Error";

class Golden extends React.Component{

  constructor(props) {
    const isLoggedIn = window.localStorage.getItem("userid") ? true : false;
    let userid = 0;
    if(isLoggedIn)
    {
    userid = window.localStorage.getItem("userid");

    }
  
    
    super(props);
    this.state = {
      golden1: '',
      golden2: '',
      golden3: '',
      userid: userid
    };
  }

  async updateGolden(user_id) {

    var data = {
      golden1: this.state.golden1,
      golden2: this.state.golden2,
      golden3: this.state.golden3

    };


    await GoldenDataService.update(user_id, data)
    .then(response => {
      if(response.data.message == 1)
      {
        //display updated comppnent
        this.setState({stage: 2});
      }
      else
      {
        //display unable to updated component
        this.setState({stage: 3});
      }
    
    })
    .catch(e => {
      console.log(e);
    });

  }

  completeGolden() {

    var data = {
      golden1: this.state.golden1,
      golden2: this.state.golden2,
      golden3: this.state.golden3,
      userid: this.state.userid


    };
    GoldenDataService.create(data)
    .then(response => {
      if(response.data != '')
      {
        this.setState({stage: 1});
      this.setState({
        golden1: response.data.golden1,
        golden2: response.data.golden2,
        golden3: response.data.golden3,

      });
    }
    else
    {
      this.setState({stage: 3});
    }
    
    })
    .catch(e => {
      this.setState({stage: 3});
      console.log(e);
    });
  }


  componentDidMount() {

    //get golden questions by user id
    GoldenDataService.get(parseInt(this.state.userid))
    .then(response => {
      if(response.data != '')
      {
      this.setState({
        golden1: response.data.golden1,
        golden2: response.data.golden2,
        golden3: response.data.golden3

      });

    }

    })
    .catch(e => {
      console.log(e);
    });

   
  }




  onChangeValueGolden1 = (event) => {
   
    this.setState({golden1: event.target.value})
  }

  onChangeValueGolden2 = (event) => {

    this.setState({golden2: event.target.value})
  }

  onChangeValueGolden3 = (event) => {

    this.setState({golden3: event.target.value})
  }

  validateForm = () => {
    return this.state.golden1 !=  '' && this.state.golden2 !=  ''  && this.state.golden3 !=  '' ;
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    if(parseInt(this.state.userid) == 0)
    {
      return;
    }
    this.setState({stage: 0});

    GoldenDataService.get(parseInt(this.state.userid))
    .then(response => {

      let data ={
        golden: 1
      }

      SignUpDataService.update(this.state.userid,data)
      .then(res => {
       
      });

      if(response.data != '')
      {
        this.updateGolden(parseInt(this.state.userid));

      }
      else if(response.data == '')
      {
        this.completeGolden();
      }
      else{
        //error panel
         let errorData = {
          message: "Error in Golden Questions",
          category: 1,
          userid: this.state.userid
        }
      
        LoggerDataService.create(errorData)
        .then(res => {
  
        });
        this.setState({stage: 3})
      }

    });


  }

render(){
return (
  <div className="container col-md-12">
     <Form onSubmit={this.handleSubmit}>

  <div  className="row background-questions">
  <div className="col-md-12 front-text font-text-color">
  {this.state.stage == 1 ? <Updated Message={'Questions created.'}/> : ''}
  {this.state.stage == 2 ? <Updated Message={'Questionnaire updated.'}/> : ''}
  {this.state.stage == 3 ? <Error Message={'Unable to update Questionnaire. Contact Help desk.'}/> : ''}
  </div>
     <div className="col-md-11 front-text">
    <span className="span">Golden Questions : </span>
    <span className="subtext">Three questions you would love to ask your future prospects</span>
    </div>
    
      <div  className="col-md-11 radio-size background">
        <b className="titletext">Question 1</b>
        <br/>
        <textarea value={this.state.golden1} onChange={this.onChangeValueGolden1} placeholder="140 characters only - Example : Ask about places where they have travelled" maxLength="140" className="title" name="text1" cols="30" rows="3"></textarea>
      </div>

      <div  className="col-md-11 radio-size background-sunlight">
        <b className="titletext">Question 2</b>
        <br/>
        <textarea  value={this.state.golden2} onChange={this.onChangeValueGolden2} placeholder="140 characters only - Example : Ask about the kind of food they like" maxLength="140" className="title" name="text2" cols="30" rows="3"></textarea>
      </div>

      <div  className="col-md-11 radio-size background-sunset">
        <b className="titletext">Question 3</b>
        <br/>
        <textarea  value={this.state.golden3} onChange={this.onChangeValueGolden3} placeholder="140 characters only - Example : Ask about their favorite sports" maxLength="140" className="title" name="text3" cols="30" rows="3"></textarea>
      </div>
  {

      this.state.golden1 !=  '' &&  this.state.golden2 !=  '' &&  this.state.golden3 !=  ''?
    
       <div className="row col-sm-12">
       <div className="col-sm-2 offset-6">
      
            <button type="submit" disabled={!this.validateForm()}><img width="75" src="save.png" alt="save image" /></button>
            <Link  to="/home"><img width="75" src="home.png" alt="save image" /></Link>
            </div> 
            <div className="col-sm-2">
    
           
            </div>
        </div>



    : ''
}
  </div>
  </Form>
  </div>

);
}

}

export default Golden;